import { formatMoneyCode } from "../../lib/formatMoney";

/**
 * How Tenant 360 words the custom price's facts (docs/auth-and-admin/super-admin-d4-customprice-contract.md
 * section 8.1): one place for money and cycle, so the badge, the modal, the notices and the price
 * history cannot write the same fact two ways. Dates go through `lib/calendarDay`.
 */
const DASH = "—";

/** `{cents, currency}` as the shared Money cell writes it ("25.00 CAD"); a dash for anything unreadable. */
export const moneyText = (money) =>
  money && Number.isFinite(money.cents) && money.currency ? formatMoneyCode(money.cents, money.currency) : DASH;

/** "25.00 CAD / month" or "/ year", through the dictionary (`t360f.customPrice.perCycle.<cycle>`). */
export const priceWithCycle = (money, cycle, t) =>
  t(`t360f.customPrice.perCycle.${cycle === "annual" ? "annual" : "monthly"}`, { price: moneyText(money) });
